import React from 'react';
import { connect } from 'react-redux';
import { uploadImageSamples } from 'registration/creative/ducks';
import ImageSamplesUpload from 'registration/creative/components/image_samples_upload';

const mapStateToProps = ({
  creativeRegistration: { workSamples, uploadingSamples, error }
}) => ({
  samples: workSamples,
  uploading: uploadingSamples,
  error
})

export default connect(mapStateToProps, {
  upload: uploadImageSamples
})(ImageSamplesUpload);



// WEBPACK FOOTER //
// ./registration/creative/containers/image_samples_upload.jsx